import React, { useState } from "react";
import { useDispatch } from "react-redux";
import UserApi from "../../api/UserApi";
import IconInfo from "../../Icons/NotificationMessage/Info";
import { ENotificationType } from "../../Model/ENotificationType";
import { User } from "../../Model/User";
import { sendNotification } from "../../redux/actions/NotificationAction";
import { getNotifications } from "../../redux/reducers/NotificationReducer";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import MtiButton from "../Buttons/MtiButton";
import CommandPanel from "../CommandPanel/CommandPanel";
import TextBox from "../Common/TextBox";
import UserUtil from "../../Utility/UserUtil";
import "./ChangePasswordPanel.css";

const PASSWORD_MISSMATCH = "The new passwords are not match!";
const PASSWORD_WEAK =
  "Password must be 6 to 20 characters which contain at least one numeric digit, one uppercase and one lowercase letter";

type Props = {
  user: User;
  style?: React.CSSProperties;
  backBtn: () => void;
};

export default function ChangePasswordPanel({ user, style, backBtn }: Props) {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const notifications = useTypedSelector((state) => getNotifications(state));
  const dispatch = useDispatch();

  const onClickChangePass = () => {
    UserApi.updateSelfPassword(oldPassword, newPassword).then((result) => {
      if (notifications.length === 0) {
        dispatch(sendNotification(ENotificationType.Success, "Change Password Success"));
        backBtn();
      }
    });
  };

  const newPasswordNotMatch = newPassword !== newPasswordConfirm;
  const passwordWeak = !UserUtil.IsUserPasswordStrong(newPassword);
  const somePasswordEmpty = newPassword === "" || newPasswordConfirm === "";
  return (
    <CommandPanel>
      <CommandPanel.UsersInfoHeader users={[user]} />
      <CommandPanel.BackArrowHeader title="Change Password" onBackArrowClick={backBtn} />
      <CommandPanel.VerticalContent>
        <div>
          <div className="password-field">
            <label className="password-label">Old Password</label>
            <TextBox
              name="oldPassword"
              value={oldPassword}
              onChange={(value) => setOldPassword(value as string)}
              variant="password"
              className="password-input"
            />
          </div>

          <div className="password-field">
            <label className="password-label">New Password</label>
            <TextBox
              name="newPassword1"
              value={newPassword}
              onChange={(value) => setNewPassword(value as string)}
              variant="password"
              className="password-input"
            />
          </div>

          <div className="password-field">
            <label className="password-label">New Password (Again)</label>
            <TextBox
              name="newPassword2"
              value={newPasswordConfirm}
              onChange={(value) => setNewPasswordConfirm(value as string)}
              variant="password"
              className="password-input"
            />
          </div>

          {(newPasswordNotMatch || passwordWeak) && !somePasswordEmpty && (
            <div style={{ marginLeft: 28 }}>
              <div className="password-not-equal">
                <IconInfo fill="#C92932" width="10" height="10" />
                <p>{newPasswordNotMatch ? PASSWORD_MISSMATCH : passwordWeak ? PASSWORD_WEAK : ""}</p>
              </div>
            </div>
          )}

          <div className="password-buttons">
            <MtiButton
              size="large"
              onClick={onClickChangePass}
              disabled={somePasswordEmpty || passwordWeak || newPasswordNotMatch}
            >
              Yes
            </MtiButton>
          </div>
        </div>
      </CommandPanel.VerticalContent>
    </CommandPanel>
  );
}
